import React from 'react';
import { createStyles, Divider, MenuItem, Typography, withStyles } from '@material-ui/core';
import { ExitToAppOutlined } from '@material-ui/icons';
import Auth from '@aws-amplify/auth';
import DropdownTab from './DropdownTab';
import UserName from './UserName';
import { useAdminAccess } from 'contexts/adminAccess';
import { resetAccess } from 'services/auth/access';

const styles = (theme) =>
  createStyles({
    icon: {
      marginRight: theme.spacing(1),
    },
    accessSummary: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      maxWidth: 320,
      whiteSpace: 'normal',
      '&.Mui-disabled': {
        opacity: 1,
      },
    },
  });

const UserMenu = ({ classes }) => {
  const { roles, canWrite, canManageBilling, canManageUsers } = useAdminAccess();
  const readOnly = !canWrite && !canManageBilling && !canManageUsers;
  const logout = () => {
    resetAccess();
    return Auth.signOut();
  };

  return (
    <DropdownTab label={<UserName />}>
      <MenuItem disabled className={classes.accessSummary}>
        <Typography variant="subtitle2" color="textPrimary">
          {roles.join(', ')}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {canWrite
            ? 'Full administration access.'
            : readOnly
              ? 'Permitted views and exports only. Changes disabled.'
              : 'Only actions assigned to your roles are enabled.'}
        </Typography>
      </MenuItem>
      <Divider />
      <MenuItem onClick={logout}>
        <ExitToAppOutlined className={classes.icon} /> Logout
      </MenuItem>
    </DropdownTab>
  );
};

export default withStyles(styles)(UserMenu);
